import { yupResolver } from '@hookform/resolvers/yup';
import CustomFieldSet from '@Modules/core/components/CustomFieldSet';
import { ChakraComponents as CC } from '@Modules/core/lib/chakra';
import { TFormUIProps } from '@Modules/core/types/FormUIPropsType';
import logPrinterFormMeta from '@Modules/terminalManagementSystem/gabManagement/containers/formHandlers/terminal/terminal/printers/meta/LogPrinterFormMeta';
import { IPrintersFormMeta } from '@Modules/terminalManagementSystem/gabManagement/containers/formHandlers/terminal/terminal/printers/meta/PrintersFormMeta';
import receiptPrinterFormMeta from '@Modules/terminalManagementSystem/gabManagement/containers/formHandlers/terminal/terminal/printers/meta/ReceiptPrinterFormMeta';
import statementPrinterFormMeta from '@Modules/terminalManagementSystem/gabManagement/containers/formHandlers/terminal/terminal/printers/meta/StatementPrinterFormMeta';
import stateFormMeta from '@Modules/terminalManagementSystem/gabManagement/containers/mixedHandlers/terminal/distributionModule/meta/StateFormMeta';
import supplierFormMeta from '@Modules/terminalManagementSystem/gabManagement/containers/mixedHandlers/terminal/distributionModule/meta/SupplierFormMeta';
import displayCustomInputs from '@Shared/utils/displayCustomInputs';
import React from 'react';
import { useForm } from 'react-hook-form';

type Props = {
    meta: IPrintersFormMeta
} & TFormUIProps;

const PrintersFormUI: React.FC<Props> = ({ onSubmit, isLoading, isSubmitting, meta }) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({ resolver: yupResolver(meta.schema) });

  return (
    <CC.Box as={'form'} onSubmit={handleSubmit(onSubmit)}>
      
      <CC.SimpleGrid
        columns={{ base: 1, lg: 2 }}
        gridRowGap={4}
        columnGap={10}
        my={4}
      >
        <CustomFieldSet title="Imprimante Journal">
          <CC.SimpleGrid
            columns={1}
            gridRowGap={4}
            columnGap={10}
            my={4}
          >
            {displayCustomInputs<IPrintersFormMeta>(
              logPrinterFormMeta,
              register,
              errors,
              isLoading,
              [],
              []
            )}
          </CC.SimpleGrid>
        </CustomFieldSet>

        <CustomFieldSet title="Imprimante Reçu">
          <CC.SimpleGrid
            columns={1}
            gridRowGap={4}
            columnGap={10}
            my={4}
          >
            {displayCustomInputs<IPrintersFormMeta>(
              receiptPrinterFormMeta,
              register,
              errors,
              isLoading,
              [],
              []
            )}
          </CC.SimpleGrid>
        </CustomFieldSet>

      </CC.SimpleGrid>

      <CustomFieldSet title="Imprimante Relevé" my={4}>
          <CC.SimpleGrid
            columns={{ base: 1, lg: 2 }}
            gridRowGap={4}
            columnGap={10}
            my={4}
          >
            {displayCustomInputs<IPrintersFormMeta>(
              statementPrinterFormMeta,
              register,
              errors,
              isLoading,
              [],
              []
            )}
          </CC.SimpleGrid>
        </CustomFieldSet>
      
    </CC.Box>
  );
};

export default PrintersFormUI;
